import { LoadingPlaceholder } from 'lib-core'


export default LoadingPlaceholder
